import store from '@/framework/store'
import checkInStore from './checkInStore'

const options = {
  install () {
    store.registerModule('checkIn', checkInStore)
  }
}

export default options
